import Axios from 'axios';

const RESOURCE_NAME_NEW_MODEL = '/Avisos/AddModel';

const oldAPI = process.env.VUE_APP_WS_ENDPOINT;

export default {
  save:{    
    setInfo(data){
      return Axios.post(RESOURCE_NAME_NEW_MODEL, data)
    }
  }
};